import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class NotificationProvider extends HttpRequest {
  // Toggle subscribe/unsubscribe on a single PO (by PO id).
  // payload: { channels }
  subscribePo (purchaseOrderId, payload = {}) {
    this.setHeader(getAuthToken())
    return this.post(`notification/purchase-orders/${purchaseOrderId}/subscribe`, payload)
  }

  updateSubscription (purchaseOrderId, payload) {
    this.setHeader(getAuthToken())
    return this.put(`notification/purchase-orders/${purchaseOrderId}/subscription`, payload)
  }

  getMySubscriptions (query) {
    this.setHeader(getAuthToken())
    return this.get('notification/subscriptions', query)
  }

  getNotifications (query) {
    this.setHeader(getAuthToken())
    return this.get('notification', query)
  }

  getUnreadCount () {
    this.setHeader(getAuthToken())
    return this.get('notification/unread-count')
  }

  markRead (id) {
    this.setHeader(getAuthToken())
    return this.put(`notification/${id}/read`)
  }

  markAllRead () {
    this.setHeader(getAuthToken())
    return this.put('notification/read-all')
  }
}

export default NotificationProvider
